var KlaviyoBackInStock = class extends HTMLElement {

    constructor() {
        super();
        this.button = this.querySelector(".klaviyo-bis-trigger");
        this.email = this.querySelector('input[type="email"]');
        this.resetEmail = this.querySelector('.backinstock-customer__email-close');
        this.form = document
    }

    connectedCallback() {
        this.button.addEventListener('click', (e) => this.handleBackInStockClick(e));

        this.email.addEventListener('blur', (e) => this.isValidEmail());

        // if user is logged in, creates the x block, else do nothing
        if (this.resetEmail != null) {
            this.resetEmail.addEventListener('click', (e) => this.clearEmailInput(e))
        }
    }

    isValidEmail() {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const result = re.test(this.email.value);
        if (result) {
            this.email.classList.remove('input-error');
        } else {
            this.email.classList.add('input-error');
            this.insertMessage('error');
        }
        return result;
    }


    handleBackInStockClick(e) {
        e.preventDefault();

        if (this.isValidEmail()) {
            this.email.classList.remove('input-error')
            const variantID = document.querySelector('form[is="product-form"] input[name="id"]').value;

            // Updated payload and fetch request as per Klaviyo documentation
            const payload = {
                "data": {
                    "type": "back-in-stock-subscription",
                    "attributes": {
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": this.email.value,
                                }
                            }
                        },
                        "channels": ["EMAIL"],
                    },
                    "relationships": {
                        "variant": {
                            "data": {
                                "type": "catalog-variant",
                                "id": `$shopify:::$default:::${variantID}` // Use the Shopify variant ID dynamically
                            }
                        }
                    }
                }
            };

            const requestOptions = {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "revision": "2024-06-15"
                },
                body: JSON.stringify(payload),
            };

            const publicApiKey = window.themeVariables.klaviyo.publicApiKey;
            const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${publicApiKey}`;

            fetch(url, requestOptions)
            fetch(url, requestOptions)
                .then(response => {
                    if (response.ok) {
                        this.insertMessage(this.email, 'success');
                        setTimeout(() => {
                            // Get the parent element with the class 'modal__content'
                            const modalContent = this.closest('.modal__content');
                            if (modalContent) {
                                modalContent.querySelector('.modal__close-button').click();
                            }
                        }, 5000);

                    } else {
                        this.insertMessage(this.email, 'error');
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.insertMessage(this.email, 'error');
                });
        }
    }

    insertMessage(status) {
        let inputClass;
        let msgClass;
        let inputMessage;
        if (status == 'error') {
            inputClass = 'input-error';
            msgClass = 'error';
            inputMessage = 'Please enter a valid email address';
        } else {
            inputClass = 'input-success';
            msgClass = 'success';
            inputMessage = 'Successfully added to Back In Stock List';
        }

        // Remove any existing message
        const existingMessage = this.email.parentNode.querySelector(`.${msgClass}`);
        if (existingMessage) {
            existingMessage.remove();
        }
        this.email.classList.add(inputClass);
        // Create and insert the message
        const message = document.createElement('div');
        message.textContent = inputMessage;
        message.classList.add(msgClass);

        // Insert the message after the email input
        this.email.parentNode.insertBefore(message, this.email.nextSibling);
        // this.email.focus();
        // Remove the message after 5 seconds
        setTimeout(() => {
            message.remove();
        }, 5000);
    }

    clearEmailInput(e) {
        const emailContainer = e.currentTarget.closest('.backinstock-customer__email-container');
        Array.from(emailContainer.children).forEach(child => child.classList.toggle('visually-hidden'));
        this.email.value = '';
        this.email.focus();
    }
};

window.customElements.define("klaviyo-backinstock", KlaviyoBackInStock);
